module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAPCAYAAAFBz9WbAAAAAXNSR0IArs4c6QAAAOBJREFUKBVtULsRgkAQvQOxFHMtwMgCiAyNkBa0BLEDGBqQhMg6LMEKNJfkfG+5vTkYdua43fdZ9tYYRF3X2fhhJdG27VYScI5JIpUx65jJ6cqV7r1EGopJAEq0i+hD4fWWN8AM15Cm6a4oipfnxsuTE4yOTqdiMVhr3yJh0TRNFRc3NdPyxDkrIDcsPSwfFjIPE4JoumceAqpNUAQUCdRcRYeTwXWaiGbkvSzLC8369thZgbyS1Fjhnw/n3BHAb3FBILQTt8gZcszwTZLkEG9zPtOieCJCJwk8QMTcB7v+AZkLY1LoagIRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/return_btn_icon.png
// module id = OXkT
// module chunks = 1